import { getCandidateDisplayName } from '../../utils/candidateName';
import { INVITE_MODAL_SIZING, INVITE_MODAL_COLORS } from '../../constants/inviteFlowModalTheme';

export const TABS = ['candidates', 'shortlist', 'insights', 'details'];

export const EXPERIENCE_BUCKETS = [
  { id: '0-1', label: '0–1 yrs', min: 0, max: 1 },
  { id: '2-3', label: '2–3 yrs', min: 2, max: 3 },
  { id: '4-6', label: '4–6 yrs', min: 4, max: 6 },
  { id: '7-10', label: '7–10 yrs', min: 7, max: 10 },
  { id: '10+', label: '10+ yrs', min: 10, max: Infinity },
];

export const AGE_BUCKETS = [
  { id: '18-24', label: '18–24', min: 18, max: 24 },
  { id: '25-30', label: '25–30', min: 25, max: 30 },
  { id: '31-35', label: '31–35', min: 31, max: 35 },
  { id: '36-40', label: '36–40', min: 36, max: 40 },
  { id: '40+', label: '40+', min: 40, max: Infinity },
];

export const CTC_BUCKETS = [
  { id: '0-5', label: '0–5 Lacs', min: 0, max: 5 },
  { id: '6-10', label: '6–10 Lacs', min: 6, max: 10 },
  { id: '11-15', label: '11–15 Lacs', min: 11, max: 15 },
  { id: '16-25', label: '16–25 Lacs', min: 16, max: 25 },
  { id: '25+', label: '25+ Lacs', min: 25, max: Infinity },
];

export function inBucket(n, bucket) {
  if (n == null || bucket == null) return false;
  const v = Number(n);
  if (Number.isNaN(v)) return false;
  return v >= bucket.min && v <= bucket.max;
}

export function resolveCandidateDisplayName(candidate) {
  return getCandidateDisplayName(candidate) || '';
}

export const inviteFlowModalStyles = `
  /* ═══ Overlay with backdrop blur ═══ */
  .invite-flow-modal-overlay {
    background: ${INVITE_MODAL_COLORS.overlay};
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    animation: inviteFlowOverlayFade 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  @keyframes inviteFlowOverlayFade {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* ═══ Modal Shell — glassmorphism + premium shadow ═══ */
  .invite-flow-modal-shell {
    width: 100%;
    max-width: ${INVITE_MODAL_SIZING.desktop.maxWidth}px;
    min-width: ${INVITE_MODAL_SIZING.desktop.minWidth}px;
    max-height: calc(${INVITE_MODAL_SIZING.desktop.maxHeightVh}vh + ${INVITE_MODAL_SIZING.desktop.maxHeightExtraPx}px);
    margin: ${INVITE_MODAL_SIZING.desktop.marginVertical}px auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: ${INVITE_MODAL_SIZING.shell.borderRadius}px;
    box-shadow:
      0 0 0 1px rgba(79, 70, 229, 0.05),
      0 4px 6px -1px rgba(0, 0, 0, 0.05),
      0 25px 50px -12px rgba(15, 23, 42, 0.18);
    animation: inviteFlowShellEnter 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes inviteFlowShellEnter {
    from { opacity: 0; transform: translateY(16px) scale(0.97); }
    to { opacity: 1; transform: translateY(0) scale(1); }
  }
  @media (max-width: 1279px) {
    .invite-flow-modal-shell {
      max-width: min(calc(100% - ${INVITE_MODAL_SIZING.tablet.paddingHorizontal}px), ${INVITE_MODAL_SIZING.tablet.maxWidth}px);
      min-width: ${INVITE_MODAL_SIZING.tablet.minWidth}px;
      max-height: calc(${INVITE_MODAL_SIZING.tablet.maxHeightVh}vh + ${INVITE_MODAL_SIZING.tablet.maxHeightExtraPx}px);
    }
  }
  @media (max-width: 767px) {
    .invite-flow-modal-shell {
      max-width: calc(100% - ${INVITE_MODAL_SIZING.mobile.paddingHorizontal}px);
      min-width: 0;
      max-height: ${INVITE_MODAL_SIZING.mobile.maxHeightVh}vh;
    }
  }

  /* ═══ Focus states ═══ */
  .invite-flow-modal-shell input:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${INVITE_MODAL_COLORS.focusRing}, 0 0 0 4px rgba(79, 70, 229, 0.15);
    border-color: ${INVITE_MODAL_COLORS.focusRing};
  }

  /* ═══ Close button ═══ */
  .invite-flow-modal-shell header button[aria-label="Close"] {
    transition: all 0.2s ease;
  }
  .invite-flow-modal-shell header button[aria-label="Close"]:hover {
    background: ${INVITE_MODAL_COLORS.closeHoverBg};
  }

  /* ═══ Footer back button hover ═══ */
  .invite-flow-modal-shell footer button:first-of-type:hover {
    background: ${INVITE_MODAL_COLORS.secondaryHoverBg};
  }

  /* ═══ Step-1 invite mode cards (link / single / bulk) ═══ */
  .invite-flow-modal-shell .invite-card-link,
  .invite-flow-modal-shell .invite-card-single,
  .invite-flow-modal-shell .invite-card-bulk {
    background: #ffffff !important;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }
  .invite-flow-modal-shell .invite-card-link::before,
  .invite-flow-modal-shell .invite-card-single::before,
  .invite-flow-modal-shell .invite-card-bulk::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.28s ease;
    pointer-events: none;
    border-radius: inherit;
  }
  .invite-flow-modal-shell .invite-card-link::before {
    background: linear-gradient(135deg, rgba(14, 165, 233, 0.04) 0%, rgba(14, 165, 233, 0.01) 100%);
  }
  .invite-flow-modal-shell .invite-card-single::before {
    background: linear-gradient(135deg, rgba(79, 70, 229, 0.04) 0%, rgba(79, 70, 229, 0.01) 100%);
  }
  .invite-flow-modal-shell .invite-card-bulk::before {
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.04) 0%, rgba(16, 185, 129, 0.01) 100%);
  }
  .invite-flow-modal-shell .invite-card-link:hover,
  .invite-flow-modal-shell .invite-card-single:hover,
  .invite-flow-modal-shell .invite-card-bulk:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px -5px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(79, 70, 229, 0.15) !important;
  }
  .invite-flow-modal-shell .invite-card-link:hover::before,
  .invite-flow-modal-shell .invite-card-single:hover::before,
  .invite-flow-modal-shell .invite-card-bulk:hover::before {
    opacity: 1;
  }
  .invite-flow-modal-shell .invite-card-link:hover {
    border-color: #0EA5E9 !important;
  }
  .invite-flow-modal-shell .invite-card-single:hover {
    border-color: #4F46E5 !important;
  }
  .invite-flow-modal-shell .invite-card-bulk:hover {
    border-color: #10B981 !important;
  }

  /* ═══ Card icon micro-animation ═══ */
  .invite-flow-modal-shell .invite-card-icon {
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .invite-flow-modal-shell .invite-card-link:hover .invite-card-icon {
    background: rgba(14, 165, 233, 0.15) !important;
    color: #0EA5E9 !important;
    transform: scale(1.08);
  }
  .invite-flow-modal-shell .invite-card-single:hover .invite-card-icon {
    background: rgba(79, 70, 229, 0.15) !important;
    color: #4F46E5 !important;
    transform: scale(1.08);
  }
  .invite-flow-modal-shell .invite-card-bulk:hover .invite-card-icon {
    background: rgba(16, 185, 129, 0.15) !important;
    color: #10B981 !important;
    transform: scale(1.08);
  }

  /* ═══ Channel selection cards (Email / SMS / WhatsApp) ═══ */
  .invite-channel-card {
    position: relative;
    overflow: hidden;
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .invite-channel-card::before {
    content: '';
    position: absolute;
    inset: 0;
    opacity: 0;
    transition: opacity 0.28s ease;
    pointer-events: none;
    border-radius: inherit;
  }
  .invite-channel-card:hover {
    transform: translateY(-3px);
  }
  .invite-channel-card:hover::before { opacity: 1; }

  .invite-channel-card--email::before {
    background: linear-gradient(135deg, rgba(79, 70, 229, 0.06) 0%, rgba(79, 70, 229, 0.02) 100%);
  }
  .invite-channel-card--email:hover {
    border-color: #4F46E5 !important;
    box-shadow: 0 8px 25px -5px rgba(79, 70, 229, 0.12), 0 0 0 1px rgba(79, 70, 229, 0.15) !important;
  }
  .invite-channel-card--email.invite-channel-card--selected {
    border-color: #4F46E5 !important;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12), 0 4px 16px -4px rgba(79, 70, 229, 0.15) !important;
  }
  .invite-channel-card--email.invite-channel-card--selected::before { opacity: 1; }

  .invite-channel-card--sms::before {
    background: linear-gradient(135deg, rgba(14, 165, 233, 0.06) 0%, rgba(14, 165, 233, 0.02) 100%);
  }
  .invite-channel-card--sms:hover {
    border-color: #0EA5E9 !important;
    box-shadow: 0 8px 25px -5px rgba(14, 165, 233, 0.12), 0 0 0 1px rgba(14, 165, 233, 0.15) !important;
  }
  .invite-channel-card--sms.invite-channel-card--selected {
    border-color: #0EA5E9 !important;
    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.12), 0 4px 16px -4px rgba(14, 165, 233, 0.15) !important;
  }
  .invite-channel-card--sms.invite-channel-card--selected::before { opacity: 1; }

  .invite-channel-card--whatsapp::before {
    background: linear-gradient(135deg, rgba(37, 211, 102, 0.06) 0%, rgba(37, 211, 102, 0.02) 100%);
  }
  .invite-channel-card--whatsapp:hover {
    border-color: #25D366 !important;
    box-shadow: 0 8px 25px -5px rgba(37, 211, 102, 0.12), 0 0 0 1px rgba(37, 211, 102, 0.15) !important;
  }
  .invite-channel-card--whatsapp.invite-channel-card--selected {
    border-color: #25D366 !important;
    box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.12), 0 4px 16px -4px rgba(37, 211, 102, 0.15) !important;
  }
  .invite-channel-card--whatsapp.invite-channel-card--selected::before { opacity: 1; }

  /* Channel icon animation */
  .invite-channel-icon {
    transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .invite-channel-card:hover .invite-channel-icon {
    transform: scale(1.1);
  }

  /* Channel checkbox animation */
  .invite-channel-check {
    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .invite-channel-check--checked {
    animation: inviteCheckPop 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  @keyframes inviteCheckPop {
    0% { transform: scale(0.5); }
    60% { transform: scale(1.2); }
    100% { transform: scale(1); }
  }

  /* ═══ Step content entrance ═══ */
  .invite-flow-modal-shell .invite-step2-content {
    animation: inviteStep2Enter 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  }
  @keyframes inviteStep2Enter {
    from { opacity: 0; transform: translateX(12px); }
    to { opacity: 1; transform: translateX(0); }
  }

  /* ═══ Step indicator ═══ */
  .invite-step-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .invite-step-dot {
    width: 8px;
    height: 8px;
    border-radius: 99px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .invite-step-dot--active {
    width: 24px;
    background: linear-gradient(135deg, #4F46E5, #6366F1);
  }
  .invite-step-dot--done {
    background: #10B981;
  }
  .invite-step-dot--upcoming {
    background: #E2E8F0;
  }

  /* ═══ Bulk template button hover ═══ */
  .invite-flow-modal-shell .invite-bulk-template-btn:hover {
    background: ${INVITE_MODAL_COLORS.secondaryHoverBg} !important;
  }

  /* ═══ Primary action button gradient + hover ═══ */
  .invite-flow-primary-btn {
    background: linear-gradient(135deg, #4F46E5, #6366F1) !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
  }
  .invite-flow-primary-btn:hover:not(:disabled) {
    box-shadow: 0 4px 15px -3px rgba(79, 70, 229, 0.4);
    transform: translateY(-1px);
  }
  .invite-flow-primary-btn:active:not(:disabled) {
    transform: translateY(0);
  }

  /* ═══ Back button ═══ */
  .invite-flow-back-btn {
    transition: all 0.2s ease;
    border-radius: 10px;
    padding: 6px 14px;
  }
  .invite-flow-back-btn:hover {
    background: #F1F5F9;
    color: #0F172A;
  }
`;

/** Keep aligned with VIDEO_PROCTORING_EYE_GAZE in server _aiInterviews.ctrl.js (used by ScreeningDetailPage tooltips). */
export const PROCTORING_EYE_GAZE_CRITERIA = Object.freeze({
  eventCap: 10,
  rawPtsPerEvent: 0.5,
  weight: 0.1,
});

/**
 * Mirrors MAX_NOTE_BODY_LENGTH in server/modules/jobs-dashboard/lib/candidateNotes.js —
 * a rejection reason is stored as a candidate note, so it shares that cap.
 */
export const MAX_REJECT_REASON_LENGTH = 2000;

/**
 * Body for the reject/restore PATCH on
 * `/api/screenings/:screeningId/candidates/:candidateId`.
 *
 * `rejectionReason` is only included when a non-empty reason is supplied, so restores and
 * orgs without `features.rejection_reason_required` keep the exact single-key payload the
 * server's reject fast-path has always accepted.
 *
 * @param {boolean} rejected
 * @param {string} [reason]
 * @returns {{rejected: boolean, rejectionReason?: string}}
 */
export function buildRejectPayload(rejected, reason = '') {
  const trimmed = String(reason || '').trim();
  return trimmed ? { rejected, rejectionReason: trimmed } : { rejected };
}
